// a react-three-fiber scene
import React, { useEffect, useState } from "react";
import { Canvas } from "@react-three/fiber";
import { Html, MapControls } from "@react-three/drei";
import { softShadows } from "@react-three/drei";
import { Floor } from "./Scene";
import Roboto from "./Roboto.json";
import * as THREE from "three";
import { animated, useSpring } from "@react-spring/three";
softShadows();
export default function Scene2() {
  let [mode, setMode] = useState(false);
  useEffect(() => {
    setTimeout(() => setMode(true), 5000);
  }, [setMode]);
  /*
          <Cube position={[-2, 2]}></Cube>
        <Cube position={[-2, 1]}></Cube>
        <Cube position={[-2, 0]}></Cube>
        <Cube small color="#aaa" position={[-1, 0]}></Cube>
        <Cube position={[-4, 2]}></Cube>
        <Cube></Cube>
        <Cube color="red" position={[1, 0]}></Cube>
        <Cube small color="#aaa" position={[4, 2]}></Cube>
        <Cube small color="#aaa" position={[3, 0]}></Cube>
        <Cube small color="#aaa" position={[2, 0]}></Cube>
        <Cube small color="#aaa" position={[-3, 2]}></Cube>
        <Cube color="teal" small position={[-2, 3]}></Cube>
        <Cube color="teal" small position={[-2, 4]}></Cube>
        <Cube color="teal" small position={[-2, 5]}></Cube>
        <Cube color="teal" small position={[-2, 6]}></Cube>
        <Cube position={[3, 1]}></Cube>
        <Cube position={[3, 2]}></Cube>
        <Cube position={[5, 2]}></Cube>
        <Cube position={[6, 2]}></Cube>
  */
  const cubes1 = [
    {
      color: "green",
      position: [0, 1],
    },
    {
      color: "green",
      position: [1, 1],
    },
    { color: "green", position: [6, 1] },
    { color: "green", position: [7, 1] },
    { color: "green", position: [7, 2] },
    { color: "green", position: [7, 3] },
    { color: "red", blink: true, position: [7, 5] },
    { color: "green", position: [7, 6] },
    { color: "green", position: [0, 7] },
    { color: "green", position: [1, 7] },
    { color: "green", position: [2, 7] },
    {
      color: "#3498db",
      bounce: true,
      delay: 0,
      position: [3, 7],
      small: true,
    },
    {
      color: "#3498db",
      bounce: true,
      delay: 1,
      position: [4, 7],
      small: true,
    },
    {
      color: "#3498db",
      bounce: true,
      delay: 2,
      position: [5, 7],
      small: true,
    },
    {
      color: "#3498db",
      bounce: true,
      delay: 3,
      position: [6, 7],
      small: true,
    },
    {
      color: "#3498db",
      bounce: true,
      delay: 4,
      position: [7, 7],
      small: true,
    },
    { color: "grey", position: [7, 4], small: true },
    { color: "grey", position: [5, 1], small: true },
    { color: "grey", position: [4, 1], small: true },
    { color: "grey", position: [3, 1], small: true },
    { color: "grey", position: [2, 1], small: true },
  ].map((e, i) => ({ ...e, id: i }));

  const cubes = [
    {
      color: "green",
      position: [0, 1],
    },
    {
      color: "green",
      position: [1, 1],
    },
    { color: "green", position: [6, 1] },
    { color: "green", position: [7, 1] },
    { color: "green", position: [7, 2] },
    { color: "green", position: [7, 3] },
    { color: "green", position: [7, 5] },
    { color: "green", position: [7, 6] },
    { color: "green", position: [0, 7] },
    { color: "green", position: [1, 7] },
    { color: "green", position: [2, 7] },
    {
      color: "#3498db",
      bounce: true,
      delay: 0,
      position: [3, 7],
      small: true,
    },
    {
      color: "#3498db",
      bounce: true,
      delay: 1,
      position: [4, 7],
      small: true,
    },
    {
      color: "#3498db",
      bounce: true,
      delay: 2,
      position: [5, 7],
      small: true,
    },
    {
      color: "#3498db",
      bounce: true,
      delay: 3,
      position: [6, 7],
      small: true,
    },
    {
      color: "#3498db",
      bounce: true,
      delay: 4,
      position: [7, 7],
      small: true,
    },
    { color: "#3498db", delay: 5, bounce: true, position: [7, 4], small: true },
    { color: "#3498db", delay: 6, bounce: true, position: [5, 1], small: true },
    { color: "#3498db", delay: 7, bounce: true, position: [4, 1], small: true },
    { color: "#3498db", delay: 8, bounce: true, position: [3, 1], small: true },
    { color: "#3498db", delay: 9, bounce: true, position: [2, 1], small: true },
  ].map((e, i) => ({ ...e, id: i * 100 }));

  return (
    <div style={{ height: "100%" }}>
      <Canvas
        draggable
        orthographic
        shadows
        camera={{ position: [5, 5, 5], zoom: 90, near: -20 }}
      >
        <group position={[-3, 0, -3]}>
          <Floor></Floor>
          <Hall name="HALLE A" w={6}></Hall>
          <Hall position={[7, 3.5]} w={6} h={12} name="HALLE B.2"></Hall>
          <Hall position={[0, 6.5]} w={6} h={6} name="HALLE B.1"></Hall>
          {(mode ? cubes1 : cubes).map((v) => {
            return (
              <Cube
                key={v.id}
                id={v.id}
                position={v.position}
                color={v.color}
                small={v.small}
                delay={v.delay}
                bounce={v.bounce}
                blink={v.blink}
              />
            );
          })}
        </group>
        <MapControls enabled={true}></MapControls>
        <directionalLight
          castShadow
          position={[2.5, 8, 5]}
          intensity={1.5}
          shadow-mapSize-width={1024}
          shadow-mapSize-height={1024}
          shadow-camera-far={50}
          shadow-camera-left={-10}
          shadow-camera-right={10}
          shadow-camera-top={10}
          shadow-camera-bottom={-10}
        />
        <ambientLight intensity={1}></ambientLight>
      </Canvas>
    </div>
  );
}

export function Hall({ w = 10, h = 5, name = "HALLE 1", position = [0, 0] }) {
  const font = new THREE.FontLoader().parse(Roboto);
  return (
    <group position={[position[0], 0, position[1]]}>
      <mesh
        position={[-w / 2 + 0.2, 0.5, -h / 2 + 0.6]}
        rotation={[-Math.PI / 2, 0, 0]}
        receiveShadow
      >
        <textGeometry
          args={[
            name,
            {
              font,
              size: 0.4,
              height: 0.02,
            },
          ]}
        ></textGeometry>
        <meshStandardMaterial color={"#444"}></meshStandardMaterial>
      </mesh>
      <mesh receiveShadow castShadow>
        <boxBufferGeometry args={[w, 1, h]} />
        <meshStandardMaterial color={"white"}></meshStandardMaterial>
      </mesh>
    </group>
  );
}

function Cube({
  position = [0, 0],
  color = "green",
  small = false,
  id,
  delay = 0,
  bounce = false,
  blink = false,
}) {
  delay = delay * 200;
  const defaultPos = [position[0], 1, position[1]];
  const [popup, setPopup] = React.useState(false);
  let { animatedPosition } = useSpring({
    from: { animatedPosition: defaultPos },
    to: [
      { animatedPosition: [position[0], 1.05, position[1]] },
      { animatedPosition: defaultPos },
    ],
    loop: { loop: true, delay: 2000 },
    config: {
      mass: 0.2,
      precision: 0.01,
      damping: 0.5,
      friction: 3,
    },
  });
  let { animatedColor } = useSpring({
    from: { animatedColor: color },
    to: { animatedColor: "#ec644b" },
    loop: { reverse: true, loop: true },
  });
  console.log(animatedColor);
  useEffect(() => {
    animatedPosition.pause();
    setTimeout(() => {
      animatedPosition.resume();
    }, delay);
  }, [delay, animatedPosition]);
  let size = small ? 0.3 : 0.9;
  return (
    <animated.mesh
      castShadow
      position={bounce ? animatedPosition : defaultPos}
      onClick={() => {
        //setPopup(true);
      }}
      onPointerDown={(e) => {
        //setMouseDown(id);
        setPopup(popup === false ? 0 : false);
        e.stopPropagation();
      }}
      onPointerUp={(e) => {
        //setMouseDown(null);
        setPopup(popup === 0 ? !popup : false);
        e.stopPropagation();
      }}
    >
      <boxBufferGeometry args={[size, size, size]} />
      {blink && (
        <animated.meshStandardMaterial
          color={blink ? animatedColor : color}
        ></animated.meshStandardMaterial>
      )}
      {!blink && <meshStandardMaterial color={color}></meshStandardMaterial>}
      {popup === true && (
        <Html>
          <div className="popup" onClick={() => setPopup(false)}>
            <div className="head">
              <div className="fakeText head"></div>
            </div>
            {color === "green" ? (
              <div className="statusWrapper">
                <div className="status">
                  <div className="dot"></div>
                  <div className="fakeText"></div>
                </div>
              </div>
            ) : (
              <div className="statusWrapper error">
                <div className="status">
                  <div className="dot"></div>
                  <div className="fakeText"></div>
                </div>
                <div className="text">
                  {" "}
                  <div className="fakeText"></div>{" "}
                  <div className="fakeText"></div>
                </div>
                <div className="status">
                  <div className="dot"></div>
                  <div className="fakeText"></div>
                </div>
                <div className="text">
                  {" "}
                  <div className="fakeText"></div>{" "}
                  <div className="fakeText"></div>
                </div>
              </div>
            )}
          </div>
        </Html>
      )}
    </animated.mesh>
  );
}
